import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function AnimatedSection({
  children,
  className = '',
  delay = 0,
  direction = 'up'
}: AnimatedSectionProps) {
  const getInitialVariants = () => {
    switch (direction) {
      case 'up':
        return {
          opacity: 0,
          y: 30
        };
      case 'down':
        return {
          opacity: 0,
          y: -30
        };
      case 'left':
        return {
          opacity: 0,
          x: 30
        };
      case 'right':
        return {
          opacity: 0,
          x: -30
        };
      case 'none':
        return {
          opacity: 0
        };
      default:
        return {
          opacity: 0,
          y: 30
        };
    }
  };
  const getAnimateVariants = () => {
    switch (direction) {
      case 'up':
      case 'down':
        return {
          opacity: 1,
          y: 0
        };
      case 'left':
      case 'right':
        return {
          opacity: 1,
          x: 0
        };
      case 'none':
        return {
          opacity: 1
        };
      default:
        return {
          opacity: 1,
          y: 0
        };
    }
  };
  return <motion.div initial={getInitialVariants()} whileInView={getAnimateVariants()} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    ease: [0.22, 1, 0.36, 1],
    delay: delay
  }} className={className} data-id="element-38">
      {children}
    </motion.div>;
}